module.exports = __webpack_public_path__ + "static/media/sam1.98ac4ab5.png";